export const HERO_MAIN_IMAGE_WIDTH = 407;
export const HERO_MIN_HEIGHT = 360;
export const BREADCRUMBS_HEIGHT = 29;
